// entries/it-IT.ts
import antdIt from "antd/lib/locale/it_IT"
import itMessages from "../locales/it_IT.json"

const ItLang = {
  messages: {
    ...itMessages
  },
  antd: antdIt,
  locale: "it-IT"
}

export default ItLang